import React from 'react'
import { useServiceOrderState } from '../../_load/ServiceOrderLoader'
import AuditListScreen from '../../../../../containers/audit/AuditListScreen'

const AuditList = () => {
  const { serviceOrder } = useServiceOrderState()
  return <AuditListScreen id={serviceOrder.id} entity={'service_order'} />
}

export default AuditList
